import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Immutable } from '../../external/immutable.js';
import { LightBox } from './LightBox.js';

/* global loader, google */ // Defined in general/loader.js

export const SchoolRequestForm = createReactClass({
    propTypes: {
        schoolId: PropTypes.number,
        location: PropTypes.object.isRequired,
        user: PropTypes.object,
        userFullName: PropTypes.string,
        userEmail: PropTypes.string,
        isTeacherRegistrationRequest: PropTypes.bool,
        isNewRequest: PropTypes.bool,
        exitHandler: PropTypes.func.isRequired,
    },

    getInitialState() {
        return {
            requestForm: Immutable.Map(),
            formErrors: {},
            formSuccessfullySent: false,
            projectsSuspended: false,
            schoolOfRequesterChanged: false,
        };
    },

    componentDidMount() {
        this.getForm();
        this.setUpAddressSuggest();
    },

    getForm() {
        loader.showPageLoaderAndShield();
        $.ajax({
            type: 'GET',
            url: '/school/school_request.html',
            data: {
                schoolId: this.props.schoolId,
                isNewRequest: this.props.isNewRequest,
                userName: this.props.userFullName,
                userEmail: this.props.userEmail,
            },
            dataType: 'json',
        }).done((data) => {
            this.setForm(data);
        }).fail(() => {
            alert('Error retrieving form, please try again.');
        }).always(() => {
            loader.removeLoader();
        });
    },

    setForm(data) {
        this.setState((prevState) => {
            return { requestForm: Immutable.fromJS(data) };
        });
    },

    setUpAddressSuggest() {
        // eslint-disable-next-line react/no-find-dom-node,react/no-string-refs
        const requestedSchoolAddressField = $(ReactDOM.findDOMNode(this.refs.requestedSchoolAddress));
        if (this.props.location && this.props.location.latLng && this.props.location.latLng.lat && this.props.location.latLng.lng) {
            const geoLoc = new google.maps.LatLng(this.props.location.latLng.lat, this.props.location.latLng.lng);
            this.autocomplete = new google.maps.places.Autocomplete(requestedSchoolAddressField[0],
                { bounds: new google.maps.LatLngBounds(geoLoc, geoLoc) });
        } else {
            this.autocomplete = new google.maps.places.Autocomplete(requestedSchoolAddressField[0]);
        }
        this.autocomplete.addListener('place_changed', this.captureAddress);
    },

    captureAddress() {
        const place = this.autocomplete.getPlace();

        this.setState((prevState) => {
            const updatedForm = prevState.requestForm.set('requestedSchoolAddress', place.formatted_address);
            return { requestForm: updatedForm };
        });
    },

    successMessageOnExit() {
        if (this.props.isTeacherRegistrationRequest) {
            if (this.props.isNewRequest) {
                this.redirectToHomepage();
            } else {
                this.props.exitHandler();
            }
        } else if (this.state.projectsSuspended) {
            this.redirectToTeacherHub();
        } else if (this.state.schoolOfRequesterChanged) {
            loader.showPageLoaderAndShield();
            window.location.reload();
        } else {
            this.props.exitHandler();
        }
    },

    redirectToHomepage() {
        window.location = baseURL;
    },

    redirectToTeacherHub() {
        window.location = secureBaseURL + 'teacher/teacher.html';
    },

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState((prevState) => {
            const updatedForm = prevState.requestForm.set(name, value);
            return { requestForm: updatedForm };
        });
    },

    submitForm() {
        const data = this.state.requestForm;
        loader.showPageLoaderAndShield();

        $.ajax({
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            url: '/school/school_request.html',
            data: JSON.stringify(data),
            dataType: 'json',
        }).done((data) => {
            this.setProjectsSuspended(data.projectsSuspended);
            this.setSchoolOfRequesterChanged(data.schoolOfRequesterChanged);
            this.setFormSuccessfullySent(true);
        }).fail((data) => {
            this.setFormSuccessfullySent(false);
            if (data.responseText) {
                try {
                    const dataJson = JSON.parse(data.responseText);
                    if (Object.keys(dataJson).length === 0) {
                        alert('Unable to make request. Please try again');
                    } else {
                        this.setFormErrors(dataJson);
                        window.scrollToPageTop();
                    }
                } catch (e) {
                    alert('Unable to make request. Please try again');
                }
            } else {
                alert('Unable to make request. Please try again');
            }
        }).always(() => {
            loader.removeLoader();
        });
    },

    setFormErrors(formErrors) {
        this.setState((prevState) => {
            return { formErrors };
        });
    },

    setFormSuccessfullySent(success) {
        this.setState((prevState) => {
            return { formSuccessfullySent: success };
        });
    },

    setProjectsSuspended(projectsSuspended) {
        this.setState((prevState) => {
            return { projectsSuspended };
        });
    },

    setSchoolOfRequesterChanged(schoolOfRequesterChanged) {
        this.setState((prevState) => {
            return { schoolOfRequesterChanged };
        });
    },

    renderSuccessMessage() {
        if (this.props.isNewRequest) {
            if (this.props.isTeacherRegistrationRequest) {
                return (
                    <div className="school-request-header">
                        <p>
                        Thank you for submitting a new school request. We&apos;ll review your school&apos;s eligibility, then notify you via email when you can finish setting up your account and submit your first project.
                        </p>
                    </div>
                );
            } else if (this.state.projectsSuspended) {
                return (
                    <div className="school-request-header">
                        <p>
                        Thank you for submitting a new school request.<strong> Your projects that are awaiting confirmation are on a temporary hold while we verify that your school is eligible.</strong> We&apos;ll notify you via email when you can resume confirming your projects.
                        </p>
                    </div>
                );
            } else {
                return (
                    <div className="school-request-header">
                        <p>
                        Thank you for submitting a new school request. We&apos;ll review your school&apos;s eligibility, and after it&apos;s approved we&apos;ll update your account and notify you via email.
                        </p>
                    </div>
                );
            }
        } else {
            if (this.props.isTeacherRegistrationRequest) {
                return (
                    <div className="school-request-header">
                        <p>
                        Thank you for updating your school information. We&apos;ll review your request and apply those changes to your account after they&apos;re approved.
                        </p>
                    </div>
                );
            } else if (this.state.projectsSuspended) {
                return (
                    <div className="school-request-header">
                        <p>
                        Thank you for updating your school information.<strong> Your projects that are awaiting confirmation are on a temporary hold while we verify your school address change.</strong> We&apos;ll notify you via email when you can resume confirming your projects.
                        </p>
                    </div>
                );
            } else {
                return (
                    <div className="school-request-header">
                        <p>
                        Thank you for updating your school information. We&apos;ll review your request and apply those changes to your account after they&apos;re approved.
                        </p>
                    </div>
                );
            }
        }
    },

    renderReasonForChange() {
        if (!this.props.isNewRequest) {
            return (
                <div className="input-holder">
                    <label htmlFor="requestedSchoolChangeReason">Reason for change*</label>
                    <textarea name="requestedSchoolChangeReason" id="requestedSchoolChangeReason" className={'requestedSchoolChangeReason ' + (this.state.formErrors.requestedSchoolChangeReason ? 'hasError' : '')} value={this.state.requestForm.get('requestedSchoolChangeReason')} onChange={this.handleInputChange} />
                    {this.state.formErrors.requestedSchoolChangeReason ? (<div className="error-text">{this.state.formErrors.requestedSchoolChangeReason}</div>) : null}
                </div>
            );
        }
    },

    renderForm() {
        return (
            <div className="form-redux school-request-form">
                {this.renderHeader()}
                <div className="school-request-form-inputs">
                    <div className="input-holder">
                        <label htmlFor="requestedSchoolName">School name*</label>
                        <input type="text" name="requestedSchoolName" id="requestedSchoolName" className={this.state.formErrors.requestedSchoolName ? 'hasError' : ''} value={this.state.requestForm.get('requestedSchoolName')} onChange={this.handleInputChange} />
                        {this.state.formErrors.requestedSchoolName ? (<div className="error-text">{this.state.formErrors.requestedSchoolName}</div>) : null}
                    </div>

                    <div className="input-holder">
                        <label htmlFor="requestedSchoolAddress">Street address*</label>
                        {/* eslint-disable-next-line react/no-string-refs */}
                        <input ref="requestedSchoolAddress" type="text" name="requestedSchoolAddress" id="requestedSchoolAddress" className={this.state.formErrors.requestedSchoolAddress ? 'hasError' : ''} value={this.state.requestForm.get('requestedSchoolAddress')} onChange={this.handleInputChange} />
                        {this.state.formErrors.requestedSchoolAddress ? (<div className="error-text">{this.state.formErrors.requestedSchoolAddress}</div>) : null}
                    </div>

                    <div className="input-holder">
                        <label htmlFor="requestedSchoolPhone">Phone number*</label>
                        <input type="tel" name="requestedSchoolPhone" id="requestedSchoolPhone" className={this.state.formErrors.requestedSchoolPhone ? 'hasError' : ''} value={this.state.requestForm.get('requestedSchoolPhone')} onChange={this.handleInputChange} />
                        {this.state.formErrors.requestedSchoolPhone ? (<div className="error-text">{this.state.formErrors.requestedSchoolPhone}</div>) : null}
                    </div>

                    <div className="input-holder">
                        <label htmlFor="requestedSchoolDistrict">District*</label>
                        <input type="text" name="requestedSchoolDistrict" id="requestedSchoolDistrict" className={this.state.formErrors.requestedSchoolDistrict ? 'hasError' : ''} value={this.state.requestForm.get('requestedSchoolDistrict')} onChange={this.handleInputChange} />
                        {this.state.formErrors.requestedSchoolDistrict ? (<div className="error-text">{this.state.formErrors.requestedSchoolDistrict}</div>) : null}
                    </div>

                    <div className="input-holder">
                        <label htmlFor="requestedSchoolPrincipalName">Principal Name*</label>
                        <input type="text" name="requestedSchoolPrincipalName" id="requestedSchoolPrincipalName" className={this.state.formErrors.requestedSchoolPrincipalName ? 'hasError' : ''} value={this.state.requestForm.get('requestedSchoolPrincipalName')} onChange={this.handleInputChange} />
                        {this.state.formErrors.requestedSchoolPrincipalName ? (<div className="error-text">{this.state.formErrors.requestedSchoolPrincipalName}</div>) : null}
                    </div>

                    <div className="input-holder">
                        <label htmlFor="requestedSchoolPrincipalEmail">Principal Email*</label>
                        <input type="text" name="requestedSchoolPrincipalEmail" id="requestedSchoolPrincipalEmail" className={this.state.formErrors.requestedSchoolPrincipalEmail ? 'hasError' : ''} value={this.state.requestForm.get('requestedSchoolPrincipalEmail')} onChange={this.handleInputChange} />
                        {this.state.formErrors.requestedSchoolPrincipalEmail ? (<div className="error-text">{this.state.formErrors.requestedSchoolPrincipalEmail}</div>) : null}
                    </div>

                    <div className="input-holder">
                        <label htmlFor="requestedSchoolWebsiteURL">School website URL</label>
                        <input type="text" name="requestedSchoolWebsiteURL" id="requestedSchoolWebsiteURL" className={this.state.formErrors.requestedSchoolWebsiteURL ? 'hasError' : ''} value={this.state.requestForm.get('requestedSchoolWebsiteURL')} onChange={this.handleInputChange} />
                        {this.state.formErrors.requestedSchoolWebsiteURL ? (<div className="error-text">{this.state.formErrors.requestedSchoolWebsiteURL}</div>) : null}
                    </div>

                    {!this.props.isNewRequest && <div className="input-holder select-holder">
                        <label htmlFor="addressType">Address Type*</label>
                        <select id='addressType' name='addressType' onChange={this.handleInputChange}>
                            <option value="Physical" selected={this.state.requestForm.get('addressType') === 'Physical'}>Physical Address</option>
                            <option value="Shipping" selected={this.state.requestForm.get('addressType') === 'Shipping'}>Shipping Address</option>
                        </select>
                        {!!this.state.formErrors.addressType && <div className="error-text">{this.state.formErrors.addressType}</div>}
                    </div>}

                    {this.renderReasonForChange()}

                    <div className="input-holder">
                        <label htmlFor="message">Additional details</label>
                        <textarea name="message" id="message" className={this.state.formErrors.message ? 'hasError' : ''} value={this.state.requestForm.get('message')} onChange={this.handleInputChange} />
                        {this.state.formErrors.message ? (<div className="error-text">{this.state.formErrors.message}</div>) : null}
                    </div>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a className="button-primary full-width" role="button" onClick={this.submitForm} onKeyPress={this.submitForm} tabIndex="0">Submit request</a>
                </div>
            </div>
        );
    },

    renderHeader() {
        if (this.props.isNewRequest) {
            return (
                <div className="school-request-header">
                    <h2>New school request</h2>
                    <p className="subheader">Enter your school information below.</p>
                </div>
            );
        } else {
            return (
                <div className="school-request-header">
                    <h2>Update school information</h2>
                    <p className="subheader">Update your school information below. We cannot ship resources to PO Boxes or personal addresses.</p>
                </div>
            );
        }
    },

    render() {
        if (this.state.formSuccessfullySent) {
            const lightboxContent = (
                <div>
                    <h2>Request received!</h2>
                    {this.renderSuccessMessage()}
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a className="button-primary" role="button" onClick={this.successMessageOnExit} onKeyPress={this.successMessageOnExit} tabIndex="0">Ok</a>
                </div>
            );
            return (
                <LightBox
                    content={lightboxContent}
                    lightboxCloseHandler={this.successMessageOnExit}
                    tier={3}
                />

            );
        } else {
            return (
                <div>
                    {this.renderForm()}
                </div>
            );
        }
    },
});
